import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DossierModelService } from './dossier-model.service';

@Injectable()
export class DossierModelResolver implements Resolve<any> {

  constructor(
    private router: Router,
    private dossierModelService: DossierModelService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.dossierModelService.dossierModel.subscribe(resolve);
    });
  }
}